import { adjustColorOpacity } from '@/utils/rgba-hexadecimal/rgba-hexadecimal';
import { Divider, Form, FormProps, Input } from 'antd';
import { styled } from 'styled-components';

export const PageContainer = styled.div`
    display: flex;
    width: 100%;
    min-height: 100vh;
    justify-content: center;
    align-items: center;
    gap: 10px;
    align-self: stretch;
`;

export const ContainerCard = styled.div`
    display: flex;
    width: 100%;
    max-width: 420px;
    padding: 12px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 10px;
    align-self: stretch;
`;

export const ContentActions = styled.div`
    width: 100%;
    display: flex;
    padding: var(--Sizes---size-regular, 16px) 0px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: var(--Sizes---size-xl, 32px);
    align-self: stretch;
`;

export const DetailsContainer = styled.div`
    width: 100%;
    display: flex;
    padding: var(--Sizes---size-xl, 32px);
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: var(--Sizes---size-xl, 32px);
    align-self: stretch;
    box-sizing: border-box;
    color: ${({ theme }) => theme.colors.text.paragraphs};

    h4 {
        width: 100%;
        margin: 0;
        text-align: center;
        /* h4 */
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
    }
`;

export const SocialButtonsContainer = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 12px;
    align-self: stretch;
`;

export const DividerStyled = styled(Divider)`	
    margin: 0 !important;
    border-color: ${({ theme }) => theme?.colors?.text?.neutral} !important;
    color: ${({ theme }) => theme?.colors?.text?.neutral} !important;
`;

export const LoginFormStyled = styled(Form)<FormProps>`
    width: 100%;
    padding: 0px;
    border: none;
    display: none;
    flex-direction: column;
    gap: 16px;
    .ant-form-item-label{
        label {
        color: ${({ theme }) => theme?.colors?.text?.headings};
        }
    }
`;

export const LoginContentInputStyled = styled(Input)`
    width: 100%;
    min-height: 41px;
    &.ant-input.ant-input-outlined {
        border-radius: ${({ theme }) => theme?.sizes?.borderRadius?.input};
        border: 1px solid ${({ theme }) => adjustColorOpacity(theme?.colors?.text?.neutral, 0.5)};
        box-shadow: none;
        color: ${({ theme }) => theme?.colors?.text?.neutral};
        
        &::placeholder {
        color: ${({ theme }) => theme?.colors?.text?.neutral};
        }
    }

    &.ant-input.ant-input-outlined:focus {
        border: 1px solid ${({ theme }) => adjustColorOpacity(theme?.colors?.text?.neutral, 0.5)};
        box-shadow: none;
    }

    &.ant-input.ant-input-outlined.ant-input-status-error {
        border-color: ${({ theme }) => theme?.colors?.theme?.error};
    }
`;

export const TermsOfService = styled.small`
    text-align: center;
`;